import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';

// window.addEventListener("error", function (event) {
//   if (event.message && event.message.includes("Extension context invalidated")) {
//     event.preventDefault();
//     return;
//   }
// });

// window.addEventListener("unhandledrejection", function (event) {
//   if (
//     event.reason &&
//     typeof event.reason.message === "string" &&
//     event.reason.message.includes("Extension context invalidated")
//   ) {
//     event.preventDefault();
//   }
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();
